'use client';
import { useLayoutEffect } from 'react';

/**
 * SiteHeader picks its cyan-vs-white background from a static pathname allowlist
 * (`MINT_HERO_ROUTES`/`MINT_HERO_PREFIXES`), since it's a layout-level client
 * component with no visibility into what a given page actually decided to render.
 * That's too coarse for routes where the SAME path pattern can render two
 * different hero styles depending on server-fetched data — e.g. /blog/[slug]
 * renders a cyan post hero OR a white silo-hub hero. Pages in that situation
 * mount this to force the header to match their real hero color via a CSS class
 * override (see `.force-white-header` in globals.css) instead of the pathname guess.
 */
export function HeaderHeroOverride({ variant }: { variant: 'white' }) {
  useLayoutEffect(() => {
    const className = variant === 'white' ? 'force-white-header' : '';
    if (!className) return;
    document.documentElement.classList.add(className);
    return () => document.documentElement.classList.remove(className);
  }, [variant]);

  return null;
}
